module.exports = __webpack_public_path__ + "img/about_bg4.2661158e.png";